import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
export var BF2GetOutskirtBuildingCafe = function (data, level, buildingState, isAccessible) {
    var config = artConfigBuildings["Cafe" + level];
    return BF2GetConfigBasedOutskirtBuilding(config);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutskirtBuildingCafe.ts
// module id = 2160
// module chunks = 3